const getVideoStream = async (constraints) => {
  const stream = await navigator.mediaDevices.getUserMedia(constraints);

  return stream;
};

export default getVideoStream;
